import React from "react";
import { ThemeProvider } from "styled-components";

import "destyle.css/destyle.css";

import Theme from "./src/themes/Theme";
import GlobalStyles from "./src/themes/GlobalStyles";

import "@fontsource/open-sans/300.css";
import "@fontsource/open-sans/400.css";
import "@fontsource/open-sans/700.css";

// Wraps every page in a component
export const wrapRootElement = ({ element }) => (
  <ThemeProvider theme={Theme}>
    <GlobalStyles />
    {element}
  </ThemeProvider>
);
